export default {
  environment: 'Production',
  isDualScreen: true,
  checkInOutURLLocal: '/Guest/CheckInOut',
  checkInOutURLDev: 'https://api.sinarmasland.com/emembers-dev/api/Guest/CheckInOut',
  checkInOutURLPrd: 'https://api.sinarmasland.com/emembers-new/api/Guest/CheckInOut',
  serverAccountURI: 'https://api.sinarmasland.com/emembers-dev/Account',
  serverGuestURI: 'https://api.sinarmasland.com/emembers-dev/Guest',
  serverMasterDataURI: 'https://api.sinarmasland.com/emembers-dev/MasterData',
  serverSalesURI: 'https://api.sinarmasland.com/emembers-dev/Sales',
  serverPOSURI: 'https://api.sinarmasland.com/emembers-dev/POS',
  serverPaymentURI: 'https://api.sinarmasland.com/emembers-dev/Payment',
  serverGateURI: 'https://api.sinarmasland.com/emembers-dev/Gate',
  serverReservationURI: 'https://api.sinarmasland.com/emembers-dev/Reservation',
  sessionTimeout: 480, // in minutes  8 hours
  fixedLayout: false,
  hideLogoOnMobile: false,
  dateFormat: 'DD.MM.YYYY',
  dateFormatSql: 'YYYY-MM-DD',
  dateTimeFormatSql: 'YYYY-MM-DD HH:mm:ss',
  urlClientHubLocal: '/clientHub',
  urlClientHubDev: 'https://api.sinarmasland.com/emembers-dev/clientHub',
  urlClientHubPrd: 'https://api.sinarmasland.com/emembers-new/clientHub',
  urlJasperReport: 'https://api.sinarmasland.com/emembers-new/report/',
  xKeyDev: 'e0db712c318d4fc6b73a02dbc7736ff0',
  xKeyPrd: '6e9e369cc9334abd999242cfc9b52a45'
}



// WEBPACK FOOTER //
// ./src/config/index.js